export const specialCaseSelectionList =  ["GENDER"]